import React, { useContext } from "react";
import { ContextProviderWrapper } from "../../../components/Context";
import { HistoryContainer } from "../History/styled";
import TableCommon from "../../../components/Common/TableCommon";
import moment from "moment";
import { ContentTableMobile } from "../../Avax/Leaderboard/styled";

export interface User {
  id: string;
  createdAt: string;
  updatedAt: string;
  version: number;
  email: string | null;
  address: string;
  name: string;
  lastLogin: string;
  isWhitelist: boolean;
  roles: string[];
  claimIndex: number;
  isLocked: boolean;
  referralCode: string;
  parentId: string | null;
  inviteCount: number;
  isJoined: boolean;
  avatar: string | null;
  bio: string | null;
}

export interface PointLog {
  id: string;
  createdAt: string;
  updatedAt: string;
  version: number;
  user_id: string;
  point: number;
  seasion_id: string;
  user: User;
}
interface RewardsHistoryProps {
  dataPoints: PointLog[] | null;
}

export const RewardsHistory = ({ dataPoints }: RewardsHistoryProps) => {
  const { theme, isMobile } = useContext(ContextProviderWrapper)!;
  const headingData = !isMobile
    ? [
        {
          name: `Time`,
          dataIndex: "createdAt",
          key: "createdAt",
          render: (data: any) => {
            return <p>{moment(data).format("MMMM DD - HH:mm")}</p>;
          },
        },
        {
          name: `Quest`,
          dataIndex: "type",
          key: "type",
          render: (data: any) => {
            return <p>{data}</p>;
          },
        },
        {
          name: `Amount`,
          dataIndex: "amount",
          key: "amount",
          render: (data: any) => {
            return <p>{data?.toFixed(4)}</p>;
          },
        },
        {
          name: `Old Point`,
          dataIndex: "old_point",
          key: "old_point",
          render: (data: any) => {
            return <p>{data?.toFixed(4)}</p>;
          },
        },
        {
          name: `New Point`,
          dataIndex: "new_point",
          key: "new_point",
          render: (data: any) => {
            return <p>{data?.toFixed(4)}</p>;
          },
        },
        // {
        //   name: `Status`,
        //   dataIndex: "status",
        //   key: "status",
        //   render: (data: any) => {
        //     return <span className="tag is-success">{data}</span>;
        //   },
        // },
      ]
    : [
        {
          name: `Transaction`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return (
              <ContentTableMobile className={theme}>
                <div className="content-right">
                  <div className="block-address">
                    <p className="address">
                      {moment(data.createdAt).format("MMMM DD - HH:mm")}
                    </p>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        Quest: <span>{data.type}</span>
                      </p>
                    </div>
                    <div className="transaction-inner">
                      <p>
                        Amount: <span> {data.amount.toFixed(4)}</span>
                      </p>
                    </div>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        Old Point: <span> {data.old_point.toFixed(4)}</span>
                      </p>
                    </div>
                    <div className="transaction-inner">
                      <p>
                        New Point: <span> {data.new_point.toFixed(4)}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </ContentTableMobile>
            );
          },
        },
      ];

  const moveToDetail = "leaderboard";
  return (
    <HistoryContainer>
      <TableCommon
        data={dataPoints}
        heading={headingData}
        moveTo={moveToDetail}
        pagination={dataPoints && dataPoints.length > 10 ? true : false}
      />
    </HistoryContainer>
  );
};

export default RewardsHistory;
